export interface IGeneralState {
    subTitle: string;
    footerTitle: string;
}

export const state: IGeneralState = {
    subTitle: '',
    footerTitle: ''
};
